const LOCALEMAP = {
    us: {
        Home: 'Home',
        Blog: 'Blog',
    },
    uk: {
        Home: 'Home',
        Blog: 'Blog',
    },
    de: {
        Home: 'Startseite',
        Blog: 'Blog',
    },
    fr: {
        Home: 'Accueil',
        Blog: 'Blog',
    },
    it: {
        Home: 'Home',
        Blog: 'Blog',
    },
    es: {
        Home: 'Inicio',
        Blog: 'Blog',
    },
    jp: {
        Home: 'ホームページ',
        Blog: 'ブログ',
    },
    kr: {
        Home: '홈',
        Blog: '블로그',
    },
    ar: {
        Home: 'الصفحة الأولى',
        Blog: 'مركز المدونة',
    },
    br: {
        Home: 'Início',
        Blog: 'Blog',
    },
    pl:{
        Home: 'Strona główna',
        Blog: 'Blog',
    },
    mx: {
        Home: 'Inicio',
        Blog: 'Blog',
    }
};

export { LOCALEMAP };
